import consumer from "./consumer"

consumer.subscriptions.create("TallySyncChannel", {
    connected() {
        // Called when the subscription is ready for use on the server
        console.log("Connected to channel....");
    },

    disconnected() {
        // Called when the subscription has been terminated by the server
    },

    received(data) {
        // Called when there's incoming data on the websocket for this channel
        if (data.event === "completed") {
            window.location.reload()
        } else if (data.event === "voucher completed") {
            // document.querySelector('[data-id="voucher-tally-loader"]').classList.remove('fa-spin');
            // document.querySelector('[data-id="voucher-tally-loader"]').classList.remove('fa-spinner');
            // document.querySelector('[data-id="voucher-tally-loader"]').classList.add('fa-check-circle');
            // document.querySelector('[data-id="upload-asset-mapping"]').classList.remove('is-hidden')
            window.location.reload()
        } else if (data.event === "upload completed") {
            window.location.reload()
        }
    }
});
